import { httpGetIds } from "../Utils";
import { httpGet, httpPost } from "../Web"
import { ApiResponse } from "./ApiResponse";
import { WorkshopUser } from "./WorkshopUser";

export interface User {
    id?: number,
    guid?: string,
    wpid?: number,

    name: string,
    email: string,
    
    companyId?: number,
    accessLevel?: number,
    status?: number,
    lastLoginTime?: string,
}

export interface UserKeyValidationResult {
    keyValid: boolean
}

export enum UserAccessLevel { Guest = 0, Tester = 1, Administrator = 2 };

export const UserAccessLevelStrings = ["Guest", "Tester", "Administrator"];

export enum UserStatus { Unknown = 0, Active = 1, Disabled = 2 };

export const UserStatusStrings = ["Unknown", "Active", "Disabled"];

export const getUser = (id: number, abortController: AbortController): Promise<ApiResponse<User>> => httpGet(`/api/user/get/${id}`, new AbortController());

export const getUserWorkshops = (id: number, abortController: AbortController): Promise<ApiResponse<WorkshopUser[]>> =>
    httpGet(`/api/user/workshop/${id}`, abortController);

export const getUserAdminWorkshops = async (id: number, abortController: AbortController): Promise<ApiResponse<WorkshopUser[]>> => {
    try {
        const userWorkshopResponse = await getUserWorkshops(id, abortController);

        if(!userWorkshopResponse.failed) {
            return {...userWorkshopResponse, result: userWorkshopResponse.result.filter(wu => wu.isWorkshopAdmin)};
        }
            
        return userWorkshopResponse;
    } catch(error) {
            return Promise.reject(error);
    }
}

export const isGlobalAdmin = async (id: number, abortController: AbortController): Promise<boolean> => {
    try {
        const userResponse = await getUser(id, abortController);

        if(userResponse.failed)
            return Promise.reject(userResponse.errorText);
        
        return Promise.resolve(userResponse.result.accessLevel === UserAccessLevel.Administrator);
    } catch(error) {
        return Promise.reject(error);
    }
}

export const isAdminUser = async (id: number, abortController: AbortController): Promise<boolean> => {
    try {
        const globalAdminResponse = await isGlobalAdmin(id, abortController);

        if(!globalAdminResponse) {
            const workshopResponse = await getUserAdminWorkshops(id, abortController);
            
            console.log('isAdminUser: ', workshopResponse);

            if(workshopResponse.failed)
                return Promise.reject(workshopResponse.errorText);
            else
                return Promise.resolve(workshopResponse.result.length > 0);
        } 
        else
            return Promise.resolve(globalAdminResponse);
        
    } catch(error) {
        return Promise.reject(error);
    } 
}

export const getAllUsers = (abortController: AbortController): Promise<ApiResponse<User[]>> => httpGet(`/api/user/`, new AbortController());

export const getDuplicateUsers = (abortController: AbortController): Promise<ApiResponse<User[]>> => httpGet(`/api/user/getduplicates`, new AbortController());

export const deleteUser = (id: number, abortController: AbortController): Promise<ApiResponse<User>> => httpGet(`/api/user/delete/${id}`, new AbortController());

export const getUsers: ((ids: number[]) => Promise<ApiResponse<User>[]>) = (ids: number[]) => httpGetIds(`/api/user/get`, ids);

export const updateUserData = (data: User, abortController: AbortController): Promise<ApiResponse<User>> =>
    httpPost(`/api/user/update`, data, abortController);